const refundOnboard = [
  "https://stgkippapps.blob.core.windows.net/img/onboard-reembolso-1.png",
  "https://stgkippapps.blob.core.windows.net/img/onboard-reembolso-2.png",
  "https://stgkippapps.blob.core.windows.net/img/onboard-reembolso-3.png",
  "https://stgkippapps.blob.core.windows.net/img/onboard-reembolso-4.png",
  "https://stgkippapps.blob.core.windows.net/img/onboard-reembolso-5.png"
];

export default refundOnboard;
